var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRampLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-120v-567l-64 63-56-56 160-160 160 160-56 56-64-63v87q0 64 26.5 117.5t64 95Q648-346 689-316t71 47l-58 58q-57-35-103-75.5T520-372v252h-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRampLeft);
export default __webpack_public_path__ + "static/media/ramp-left.2d28aec3ccfe4ad67af427d21c4bfea4.svg";
export { ForwardRef as ReactComponent };